<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { balanceDetailsPageUserDetail } from '@/api/biz/userDetail'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'BalanceDetailsTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('业务流水号'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户昵称'),
          dataIndex: 'userNickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作前余额'),
          dataIndex: 'beforeBalance',
          align: 'center'
        },
        {
          title: this.$t('变动余额'),
          dataIndex: 'balance',
          align: 'center'
        },
        {
          title: this.$t('操作后余额'),
          dataIndex: 'afterBalance',
          align: 'center'
        },
        {
          title: this.$t('类型'),
          dataIndex: 'billType',
          scopedSlots: { customRender: 'billType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('方向'),
          dataIndex: 'changeType',
          scopedSlots: { customRender: 'changeType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      balanceDetailsPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="changeType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.AccountChangeTypeEnum" :color="true" :color-array="['green', 'red']" :value="record.changeType" />
      </span>
      <span slot="billType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.UserBalanceTypeEnum" :color="true" :value="record.billType" />
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
